import { render, staticRenderFns } from "./price-and-discounts-wrapper.vue?vue&type=template&id=fd1539dc"
import script from "./price-and-discounts-wrapper.vue?vue&type=script&lang=js"
export * from "./price-and-discounts-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports